
export default function areAllPropertiesFilled(data) {
    for (const key in data) {
      if (!data[key]) {
        return false; // If any property is empty or falsy, return false
      }
    }
    return true; // All properties have values
  }
